import { Box, Container, Typography } from '@mui/material';
import GetProyectos from './GetProyectos';
export default function Busqueda({ Datos }) {
  return (
    <Box>

      {/* ── HERO SECTION ── */}
      <Box
        sx={{
          background: '#000000',
          py: { xs: 5, md: 7 },
          px: 2,
        }}
      >
        <Container maxWidth="lg">
          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                mt: 0.5,
              }}
            >
              <Box
                component="img"
                src="/logotalsa.png"
                alt="Talsa Logo"
                sx={{ height: 90, objectFit: 'contain' }}
              />
            </Box>
            <Box>
              <Typography
                sx={{
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: 700,
                  fontSize: { xs: '22px', md: '28px' },
                  color: '#ffffff',
                  lineHeight: 1.3,
                  mb: 1,
                }}
              >
                Consulta el estado de tus solicitudes
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: 400,
                  fontSize: '15px',
                  color: '#9aa5b4',
                  maxWidth: 520,
                }}
              >
                Ingresa tu número de cédula o NIT incluyendo el dígito de verificación para ver el estado de tus proyectos de servicio técnico.
              </Typography>
            </Box>
          </Box>
        </Container>
      </Box>

      {/* ── CONTENIDO DE BÚSQUEDA ── */}
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <GetProyectos Datos={Datos} />
      </Container>

    </Box>
  );
}
